export const FirstCommandKeys = ["control", "alt"] as const;
export const SecondCommandKeys = ["shift"] as const;
export const CommandKeys = [...FirstCommandKeys, ...SecondCommandKeys] as const;
// might be a better way to do this
const Alphabet = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
] as const;
const Numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"] as const;
const Symbols = ["`", "-", "=", "[", "]", "\\", ";", "'", ",", ".", "/"] as const;
export const NonCommandKeys = [
  "enter",
  "space",
  "backspace",
  "delete",
  "tab",
  "escape",
  "arrowup",
  "arrowdown",
  "arrowleft",
  "arrowright",
  ...Alphabet,
  ...Numbers,
  ...Symbols,
] as const;
export const keyToVal: Record<string, string> = {
  " ": "space",
  "!": "1",
  "@": "2",
  "#": "3",
  $: "4",
  "%": "5",
  "^": "6",
  "&": "7",
  "*": "8",
  "(": "9",
  ")": "0",
  "~": "`",
  _: "-",
  "+": "=",
  "{": "[",
  "}": "]",
  "|": "\\",
  ":": ";",
  '"': "'",
  "<": ",",
  ">": ".",
  "?": "/",
};
type FirstCommand = (typeof FirstCommandKeys)[number];
type SecondCommand = (typeof SecondCommandKeys)[number];
export type CommandKey = (typeof CommandKeys)[number];
type OtherKey = (typeof NonCommandKeys)[number];
export type KeyList =
  | [FirstCommand, ...OtherKey[]]
  | [FirstCommand, SecondCommand, ...OtherKey[]]
  | [FirstCommand, SecondCommand, SecondCommand, ...OtherKey[]];
export type Key = FirstCommand | SecondCommand | OtherKey;

export type KeyboardShortcut = {
  keys: KeyList;
  handler: () => void;
  disabled?: boolean;
  name: string;
};
